const STYLES = {
  High: "text-red-700 bg-red-50 border-red-200",
  Medium: "text-amber-700 bg-amber-50 border-amber-200",
  Low: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Overstock: "text-sky-700 bg-sky-50 border-sky-200",
  "Slow Moving": "text-slate-700 bg-slate-100 border-slate-200",
  Healthy: "text-emerald-700 bg-emerald-50 border-emerald-200",
  "Stockout Risk": "text-red-700 bg-red-50 border-red-200",
};

export default function RiskBadge({ level, className = "", testid }) {
  const style = STYLES[level] || "text-slate-700 bg-slate-100 border-slate-200";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium border ${style} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {level}
    </span>
  );
}
